import React, { useState } from 'react';

const EllipsisDropdown = ({ actions = [] }) => {

    const [showMenu, setShowMenu] = useState(false);
    
    return (
        <>
            { actions.length > 0 &&
                <span className="position-relative pl-2 pr-3 py-1 ml-auto" role="button"
                    onClick={() => setShowMenu((v) => !v)}
                    onBlur={() => setTimeout(() => setShowMenu(false), 150)}
                    onKeyDown={(e) => {
                        if (e.key === 'Escape' || e.key === 'Esc') {
                            if (e.target && typeof e.target.blur === 'function') e.target.blur();
                        }
                    }}
                    tabIndex={0}
                >
                    <i className="fas fa-ellipsis-v fa-xl"></i>
                    {showMenu && (
                        <div className="dropdown-menu show p-0 mt-1 shadow border-0 position-absolute end-0" style={{ minWidth: '160px', zIndex: 1000, right: 0, left: 'auto' }}>
                            { actions.map((action, idx) => (
                                <button
                                    key={idx}
                                    className="dropdown-item w-100 text-left"
                                    type="button"
                                    onClick={() => { setShowMenu(false); action.onClick && action.onClick(); }}
                                >
                                    {action.label}
                                </button>
                            ))}
                        </div>
                    )}
                </span>
            }
        </>
    );
};

export default EllipsisDropdown;
